module.exports = "<div class=\"curDate\">\n    {{ curDate | date:'dd/MM/yyyy'}}\n</div>"